import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
import SkeletonL from "../Components/Skeleton/Withlogin";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
// import JobGuarantee from "../Components/Dashboard/job-guarantee/job-guarantee";

const JobGuarantee = lazy(() => import('../Components/Dashboard/job-guarantee/job-guarantee'));
const AuthJobguarantee = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <JobGuarantee/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthJobguarantee;


